import { ApiSmStateSnapshotSchema } from "@bridge-applications/pb-types";
import { z } from "zod";

export const SlotMachineSliceSchema = z.object({
    snapshot: ApiSmStateSnapshotSchema.nullable(),
    loadStatus: z.enum(["idle", "loading", "ready", "error"]),
    loadError: z.string().nullable(),
    spinStatus: z.enum(["idle", "spinning"]),
    spinError: z.string().nullable(),
    refreshRequestedRevision: z.number().int().nonnegative(),
    refreshCompletedRevision: z.number().int().nonnegative(),
});

export type SlotMachineSlice = z.infer<typeof SlotMachineSliceSchema>;
